
function TestimonialCard(props) {
 
  return (
    <div className="testimonial-card">
        <div className="profile-info">
            <img loading="lazy" src={props.clientImg} alt="" />
            <div className="profile-info-text">
              <h5>{props.clientName}</h5>
              <img alt="stars" loading="lazy" src="/images/icons/rating-stars.svg" style={{borderRadius:0}}/>
            </div>
        </div>
        <p>{props.clientReview}</p>

        <div className="testimonial-card-info">
          <p className="d-flex align-items-center gap-2">{props.count} <div style={{width:"35px",border:"1px solid #8F8F8F",margin:"auto"}}></div> {props.total}</p>
          <div className="testimonial-card-control gap-md-5 gap-3">
            <div className="swiper-button-prev" onClick={props.handlePrevButtonClick}>
                <img alt="icon" loading="lazy" src="/images/icons/arrow-left.svg"/>
            </div>
            <div className="swiper-button-next" onClick={props.handleNextButtonClick}>
                <img alt="icon" loading="lazy" src="/images/icons/arrow-right.svg"/>
            </div>
          </div>
        </div>
    </div>
  )
}

export default TestimonialCard